import Info from "@solundo/webshop/js/info/Info";
new Info();